<template>
  <b-row>
    <b-col cols="12" class="mt-3">
      <b-card header-class="custom-header-bg">
        <template v-slot:header>
          <div class="border-left custom-header-border float-left mt-1">
            <span class="mb-0 h3 ml-2">商品管理</span>
          </div>
          <b-button variant="primary" class="border float-right" @click="onClickAddProduct" :disabled="isAddingProd">新增商品</b-button>
        </template>
        <b-navbar class="mt-2">
          <b-navbar-nav>
            <b-form inline>
              <label class="sr-only" for="state-radio-btn-outline">商品狀態：</label>
              <b-form-radio-group
                id="state-radio-btn-outline"
                v-model="stateInput"
                :options="stateOptions"
                buttons
                button-variant="outline-info"
                size="sm"
                name="state-radio-btn-outline"
              ></b-form-radio-group>
            </b-form>
          </b-navbar-nav>
        </b-navbar>
        <b-navbar toggleable="md" class="mt-2">
          <b-navbar-nav>
            <b-nav-form inline class="mr-md-2 mt-2">
              <label class="mr-sm-2" for="inline-form-input-serialNumInput">商品編號：</label>
              <b-form-input id="inline-form-input-serialNumInput" v-model="serialNumInput"></b-form-input>
            </b-nav-form>
            <b-nav-form inline class="mr-md-2 mt-2">
              <label class="mr-sm-2" for="inline-form-input-nameInput">商品名稱：</label>
              <b-form-input id="inline-form-input-nameInput" v-model="nameInput"></b-form-input>
            </b-nav-form>
          </b-navbar-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-item class="mr-1">
              <b-button
                :disabled="!selectedArray.length"
                variant="danger"
                size="sm"
                @click="onClickDelete"
              >刪除商品</b-button>
            </b-nav-item>
			<b-nav-form class="pr-2 mr-1">
              <b-form-select v-model="selectedClassify" size="sm">
                <b-form-select-option :value="null">全部分類</b-form-select-option>
                <b-form-select-option v-for="item in topClassify" :key="item.id" :value="item.id">{{ item.name }}</b-form-select-option>
              </b-form-select>
            </b-nav-form>
            <b-nav-form>
              <b-form-select v-model="each" size="sm">
                <b-form-select-option v-for="n in [10, 20, 30, 50]" :value="n" :key="n">每頁顯示筆數: {{ n }}</b-form-select-option>
              </b-form-select>
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>
        <b-table
          id="production-table"
          bordered
          show-empty
          empty-text="搜尋結果：無商品"
          hover
          :items="items"
          :fields="fields"
          :busy="Boolean(isBusy)"
          responsive
          class="mt-2"
          head-variant="light"
        >
          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:head(checkbox)>
            <b-form-checkbox id="checkbox-all" @change="onClickSelectAll" :indeterminate="isParticalSelected">選取</b-form-checkbox>
          </template>
          <template v-slot:cell(checkbox)="data">
            <b-form-checkbox
              :id="`checkbox-${data.item.id}`"
              v-model="selectedArray"
              :value="data.item.id"
            >
            </b-form-checkbox>
          </template>
          <template v-slot:cell(pics)="data">
            <b-img thumbnail fluid v-for="(pic, idx) in data.value" :key="pic.id" width="48" height="48" :src="getCatalogThumb(data.item.id, pic.id)" :alt="`Image-${idx}`"></b-img>
          </template>
          <template v-slot:cell(sr)="data">
            <ul class="list-unstyled mb-0 text-left" style="justify-content: center; display: grid;">
              <li v-for="size in data.value" :key="size.id">
                {{size.name}} / <b-badge :variant="getSizeRemainsVariant(size.amount)">{{size.amount}}</b-badge>
              </li>
            </ul>
          </template>
          <template v-slot:cell(state)="data">
            <span :class="getStateColor(data.value)">{{ data.value | ProductStateFormatter }}</span>
          </template>
          <template v-slot:cell(ops)="data">
            <b-link :to="`/admin/product/${data.item.id}/edit`" class="mr-1">編輯</b-link>
            <b-link :to="`/prod/${data.item.id}`" target="_blank" class="ml-1">預覽</b-link>
          </template>
        </b-table>
        <b-pagination
          v-show="!Boolean(isBusy)"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="each"
          aria-controls="production-table"
          class="float-right"
        ></b-pagination>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import QueryString from 'querystring'
import { ProductState } from '../../library/Var.js'
export default {
  data () {
    return {
      currentPage: 1,
      rows: 0,
      each: 10,
      items: [],
      isBusy: false,
      isAddingProd: false,
      selectedArray: [],
      topClassify: [],
      stateInput: null,
      serialNumInput: '',
      nameInput: '',
      selectedClassify: null
    }
  },
  computed: {
    stateOptions () {
      return [
        { text: '全部商品', value: null },
        { text: '未上架', value: 'unpublish' },
        { text: '上架中', value: 'sale' },
        { text: '已下架', value: 'discontinue' }
      ]
    },
    fields () {
      return [
        { key: 'checkbox', label: '選取', tdClass: 'text-center' },
        { key: 'serialNum', label: '商品編號', tdClass: 'text-center' },
        { key: 'pics', label: '商品圖片', tdClass: 'text-center' },
        { key: 'classify', label: '商品分類', tdClass: 'text-center' },
        { key: 'name', label: '商品名稱', tdClass: 'text-center' },
        { key: 'sr', label: '規格 / 庫存數' },
        { key: 'price', label: '售價', tdClass: 'text-center' },
        { key: 'sellCount', label: '銷售總數', tdClass: 'text-center' },
        { key: 'state', label: '商品狀態', tdClass: 'text-center' },
        { key: 'ops', label: '操作', tdClass: 'text-center' }
      ]
    },
    query () {
      const obj = {
        page: this.currentPage,
        each: this.each
      }
      if (this.serialNumInput) {
        obj.serial_number = this.serialNumInput
      }
      if (this.nameInput) {
        obj.name = this.nameInput
      }
      if (this.stateInput) {
        obj.state = this.stateInput || 'all'
      }
      if (this.selectedClassify) {
        obj.classify = this.selectedClassify
      }
      const str = QueryString.stringify(obj)
      return `?${str}`
    },
    isParticalSelected () {
      return this.selectedArray.length !== 0 && this.items.length !== 0 && this.items.length !== this.selectedArray.length
    }
  },
  methods: {
    async fetchClassify () {
      const { data } = await this.$api.getClassifyMain()
      data.sort((a, b) => a.sort - b.sort)
      this.topClassify = data.map(item => {
        const { id, name } = item
        return { id, name }
      })
    },
    async fetch () {
      if (this.isBusy) {
        clearTimeout(this.isBusy)
      }
      this.isBusy = setTimeout(async () => {
        try {
          const { data: { catalogs }, headers } = await this.$api.getProdParam(this.query)
          this.items = catalogs.map(item => {
            const topName = item.top ? item.top.name : ''
            const subName = item.sub ? item.sub.name : ''
            return {
              id: item.id,
              serialNum: item.serial_number,
              pics: item.pics,
              topClassify: item.top,
              subClassify: item.sub,
              classify: [topName, subName].join(' / '),
              name: item.name,
              sr: item.size,
              price: item.price,
              sellCount: item.size.reduce((prevSum, next) => prevSum + next.counter, 0),
              state: item.state
            }
          })
          this.rows = Number.parseInt(headers['shop-option-total']) || 0
        } catch (err) {
          console.log(err)
        } finally {
          this.isBusy = false
        }
      }, 1000)
    },
    async onClickDelete () {
      if (this.isBusy) return
      this.isBusy = true
      const wait = this.selectedArray.map(id => this.$api.delProd(id))
      try {
        await Promise.all(wait)
        this.showToast(true)
        this.isBusy = false
        this.selectedArray = []
        await this.fetch()
      } catch (err) {
        console.log(err)
        this.showToast(false)
      }
    },
    getCatalogThumb (cid, pid) {
      return this.$api.catalogThumbImageLink(cid, pid)
    },
    getSizeRemainsVariant (n) {
      if (n > 10) {
        return 'success'
      } else if (n > 0) {
        return 'warning'
      } else {
        return 'danger'
      }
    },
    getStateColor (v) {
      if (v === 'isExpired') {
        return 'text-danger'
      } else if (v === 'onSale') {
        return 'text-success'
      } else {
        return ''
      }
    },
    showToast (success) {
      if (success) {
        this.$bvToast.toast('資料已更新。', {
          variant: 'success',
          title: '操作成功'
        })
      } else {
        this.$bvToast.toast('連線失敗，資料未成功修改。', {
          variant: 'danger',
          title: '發生錯誤'
        })
      }
    },
    async onClickAddProduct () {
      if (this.isAddingProd) return
      this.isAddingProd = true
      try {
        const { data } = await this.$api.postProd()
        this.$router.push(`/admin/product/${data.id}/edit`)
      } catch (err) {
        console.log(err)
        this.showToast(false)
      }
    },
    onClickSelectAll (val) {
      let array = []
      if (val) {
        array = this.items.map(item => item.id)
      }
      this.selectedArray = array
    }
  },
  filters: {
    ProductStateFormatter (val) {
      return ProductState[val] || '草稿'
    }
  },
  mounted () {
    this.fetchClassify()
    this.fetch()
  },
  watch: {
    query () {
      this.fetch()
    }
  }
}
</script>
